import { apiFetch } from '../lib/api';

export function login(email, password) {
  return apiFetch('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });
}

export function signup(payload) {
  return apiFetch('/api/auth/signup', {
    method: 'POST',
    body: JSON.stringify({
      ...payload,
      redirectTo: window.location.origin + '/auth/callback?from=signup'
    })
  });
}

export function forgotPassword(email) {
  return apiFetch('/api/auth/forgot', {
    method: 'POST',
    body: JSON.stringify({
      email,
      redirectTo: window.location.origin + '/reset-password'
    })
  });
}

export function exchangeCode(code) {
  return apiFetch('/api/auth/exchange', {
    method: 'POST',
    body: JSON.stringify({ code })
  });
}

export function updatePassword(accessToken, password) {
  return apiFetch('/api/auth/update-password', {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}` },
    body: JSON.stringify({ password })
  });
}

export function logout() {
  return apiFetch('/api/auth/logout', { method: 'POST' });
}

// /auth/v1/user proxy'si
export function getUser(accessToken) {
  return apiFetch('/api/auth/user', {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
}


